import React, { useEffect, useRef, useState } from 'react';

const MapViewer = () => {
  const mapRef = useRef(null);
  const [mapLoaded, setMapLoaded] = useState(false);

  const latitudes = [23.7104, 23.7104, 23.7263, 23.71046, 23.80409, 23.8179, 23.7278];
  const longitudes = [90.4071, 90.4074, 90.4165, 90.40738, 90.41524, 90.4103, 90.4135];

  useEffect(() => {
    // Load Leaflet CSS
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.css';
    document.head.appendChild(link);

    // Load Leaflet JS
    const script = document.createElement('script');
    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.js';
    script.onload = () => setMapLoaded(true);
    document.body.appendChild(script);

    return () => {
      document.head.removeChild(link);
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    if (!mapLoaded || !mapRef.current) return;

    // Calculate center point
    const centerLat = latitudes.reduce((a, b) => a + b) / latitudes.length;
    const centerLng = longitudes.reduce((a, b) => a + b) / longitudes.length;

    // Calculate radius (max distance from center)
    const distances = latitudes.map((lat, i) => {
      const lng = longitudes[i];
      const R = 6371000; // Earth's radius in meters
      const dLat = (lat - centerLat) * Math.PI / 180;
      const dLng = (lng - centerLng) * Math.PI / 180;
      const a = Math.sin(dLat/2) * Math.sin(dLat/2) +
                Math.cos(centerLat * Math.PI / 180) * Math.cos(lat * Math.PI / 180) *
                Math.sin(dLng/2) * Math.sin(dLng/2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
      return R * c;
    });
    const radius = Math.max(...distances);

    // Create map
    const map = window.L.map(mapRef.current).setView([centerLat, centerLng], 12);

    // Add tile layer
    window.L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© OpenStreetMap contributors'
    }).addTo(map);

    // Add circle
    window.L.circle([centerLat, centerLng], {
      color: 'red',
      fillColor: '#f03',
      fillOpacity: 0.2,
      radius: radius
    }).addTo(map).bindPopup(`Radius: ${radius.toFixed(2)} meters`);

    // Add markers for each point
    latitudes.forEach((lat, i) => {
      window.L.marker([lat, longitudes[i]])
        .addTo(map)
        .bindPopup(`Point ${i + 1}<br>Lat: ${lat}<br>Lng: ${longitudes[i]}`);
    });

    // Add center marker
    window.L.marker([centerLat, centerLng], {
      icon: window.L.divIcon({
        className: 'center-marker',
        html: '<div style="background-color: blue; width: 10px; height: 10px; border-radius: 50%; border: 2px solid white;"></div>',
        iconSize: [10, 10]
      })
    }).addTo(map).bindPopup(`Center<br>Lat: ${centerLat.toFixed(5)}<br>Lng: ${centerLng.toFixed(5)}`);

    return () => {
      map.remove();
    };
  }, [mapLoaded]);

  return (
    <div className="w-full h-screen flex flex-col">
      <div className="bg-blue-600 text-white p-4">
        <h1 className="text-2xl font-bold">Tracely</h1>
        <p className="text-sm mt-1">Dhaka, Bangladesh - {latitudes.length} points marked</p>
      </div>
      <div ref={mapRef} className="flex-1 w-full" />
      {!mapLoaded && (
        <div className="absolute inset-0 flex items-center justify-center bg-gray-100">
          <p className="text-gray-600">Loading map...</p>
        </div>
      )}
    </div>
  );
};

export default MapViewer;
